import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {formatCurrency} from "@angular/common";

export interface DistributionsTable {
  field: string;
  value: string;
}

@Component({
    selector: 'deal-distributions-table',
    templateUrl: './distributions-table.component.html',
    styleUrls: ['./distributions-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DistributionsTableComponent {
  @Input() distributions: any;

  dColumns: string[] = ['field', 'value'];
  dDataSource: MatTableDataSource<DistributionsTable>;

  ngOnInit() {
    let formatted: Array<DistributionsTable> = [];
    for(let i = 0; i < this.distributions.length; i++){
      formatted.push({field: this.distributions[i]['ownedEntity']['name'], value: formatCurrency(this.distributions[i]['amount'], 'EN', '$', 'USD', '1.0-0')});
    }

    this.dDataSource = new MatTableDataSource(formatted);
  }
}
